import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Stack } from '@mui/material';
import { checkAvailability } from '../../../utils'
import { __permissions, __snackBarSeverity, __snackBarText } from '../../../constants';
import { useTheme } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import styled from '@emotion/styled';
import mainContext from '../../../contexts/mainContext';
import { editSubAdmin, getRolesListing } from '../../../Controllers/RoleManagement';
import Avatar from '@mui/material/Avatar';
import CloseIcon from '@mui/icons-material/Close';
import SelectDialCode from '../../Common/SelectDialCode';

const S3_PUBLIC_DOMAIN = process.env.REACT_APP_S3_PUBLIC_DOMAIN;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const SubAdminProfile = ({ canvasState, setCanvasState, cb }) => {
    const [state, setState] = useState({
        supportRoles: [],
        role: canvasState.user.role,
        roleId: 0
    })
    const { setSnackBar, setCanvasTitle } = React.useContext(mainContext);
    const [editable, setEditable] = useState(false)
    const [profilePicUrl, setProfilePicUrl] = useState("")
    const [mobileNumber, setMobileNumber] = useState("");
    const [metaState, setMetaState] = useState({ firstName: canvasState.user.firstName, lastName: canvasState.user.lastName, email: canvasState.user.email })


    useEffect(() => {
        getRoles()
        return () => { }
    }, [])

    const getRoles = async () => {
        const res = await getRolesListing();
        if (res.data.status === 200) {
            setState({ ...state, ...res.data.data, load: false })
        } else {
            setState({ ...state, load: false, error: res.data.message })
        }
    }

    const handleUpdate = async () => {

        const file = document.getElementById("pic").files;
        const formdata = new FormData();
        formdata.append("userId", canvasState.user._id)
        formdata.append("firstName", document.getElementById("firstName").value)
        formdata.append("status", document.getElementById("status").innerText)
        formdata.append("lastName", document.getElementById("lastName").value)
        formdata.append("email", document.getElementById("email").value)
        formdata.append("mobileNo", mobileNumber ? mobileNumber.phone.replace(mobileNumber.country.dialCode, "") : "")
        formdata.append("dialCode", mobileNumber ? `+${mobileNumber.country.dialCode}` : "")
        formdata.append("roleId", state.roleId)
        
        if (!formdata.get("email") || formdata.get("email")) {
            const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            const email = reg.test(formdata.get("email").toLowerCase());
            if (!email) {
                return setSnackBar({
                    status: true,
                    text: "Please enter valid email.",
                    severity: __snackBarSeverity.error
                });
            }
        }
        try {
            if (file && file.length !== 0) {
                if (!checkAvailability(file[0].type)) {
                    return setSnackBar({
                        status: true,
                        text: "Unsupported File",
                        severity: __snackBarSeverity.error
                    });
                }
                formdata.append("pic", file[0]);
            }
        } catch (error) {

        }

        const res = await editSubAdmin(canvasState.user._id, formdata);
        if (res.data.status === 200) {
            cb(res.data.data, canvasState.index)
            return setSnackBar({
                status: true,
                text: res.data.message,
                severity: __snackBarSeverity.success
            });
        }
        else {
            return setSnackBar({
                status: true,
                text: res.data.errors[0].message,
                severity: __snackBarSeverity.error
            });
        }

    }

    const handlePictureOnChange = () => {
        const objectUrl = URL.createObjectURL(document.getElementById("pic").files[0])
        setProfilePicUrl(objectUrl)
    }

    React.useEffect(() => {
        setCanvasTitle("Sub admin profile");
        // eslint-disable-next-line
    }, [])

    const handleSelect = (e) => {
        state.supportRoles.some((object) => {
            if (object.role === e.target.value) {
                setState({ ...state, role: e.target.value, roleId: object.role })
            }
        })
    }

    return (
        <>
            <Container>
                <Header>
                    <h4>Sub admin profile</h4>
                    <CloseIcon className='pointer' onClick={() => { setCanvasState({ ...canvasState, open: false }) }} />
                </Header>

                <>
                    <Body className='scroll-bar-hidden'>
                        {canvasState.user.referralCode && <h4 style={{ margin: '10px' }}>#{canvasState.user.referralCode}</h4>}
                        <TextField sx={{ marginTop: '10px' }}
                            id='status'
                            fullWidth
                            select
                            label="Status"
                            defaultValue={canvasState.user.status}
                            disabled={!editable}
                        >
                            <MenuItem
                                value={"Active"}>
                                Active
                            </MenuItem>
                            <MenuItem

                                value={"Inactive"}>
                                Inactive
                            </MenuItem>
                        </TextField>
                        <Stack spacing={3}>
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{ marginTop: "1rem" }}>
                                <TextField
                                    id='firstName'
                                    fullWidth
                                    label="First name"
                                    value={metaState.firstName}
                                    disabled={!editable}
                                    inputProps={{ maxLength: 30 }}
                                    onChange={(e) => {
                                        if (e.target.value) {
                                            const reg = new RegExp(/^[a-zA-Z ,.-]*$/gi)
                                            const res = reg.test(e.target.value.replace(/\n/g, " "));
                                            if (res) {
                                                setMetaState({ ...metaState, firstName: e.target.value })
                                            }
                                        } else {
                                            setMetaState({ ...metaState, firstName: "" })

                                        }
                                    }}
                                />

                                <TextField
                                    id='lastName'
                                    fullWidth
                                    label="Last name"
                                    value={metaState.lastName}
                                    disabled={!editable}
                                    inputProps={{ maxLength: 30 }}
                                    onChange={(e) => {
                                        if (e.target.value) {
                                            const reg = new RegExp(/^[a-zA-Z ,.-]*$/gi)
                                            const res = reg.test(e.target.value.replace(/\n/g, " "));
                                            if (res) {
                                                setMetaState({ ...metaState, lastName: e.target.value })
                                            }
                                        } else {
                                            setMetaState({ ...metaState, lastName: "" })

                                        }
                                    }}
                                />
                            </Stack>

                            <TextField
                                id='email'
                                fullWidth
                                autoComplete="email"
                                type="email"
                                label="Email address"
                                defaultValue={metaState.email}
                                disabled={!editable}
                            />

                            <SelectDialCode setMobileNumber={setMobileNumber} subAdmin={canvasState.user} />
                            <h5>Profile picture</h5>
                            <div style={{
                                marginTop: "0",
                                display: "flex",
                                alignItems: "center",
                                columnGap: "1rem"
                            }}>
                                <Avatar
                                    alt={canvasState.user.firstName}
                                    src={profilePicUrl || S3_PUBLIC_DOMAIN  + canvasState.user.profilePicture}
                                    sx={{ width: 50, height: 50 }}
                                    style={{
                                        marginLeft: "1rem",
                                        marginTop: "0.4rem"
                                    }}
                                />
                                <Button variant="contained" size='small' onClick={() => { document.getElementById("pic").click() }} disabled={!editable}>change profile</Button>
                            </div>
                            <TextField
                                style={{
                                    display: "none"
                                }}
                                id='pic'
                                fullWidth
                                type="file"
                                disabled={!editable}
                                onInput={handlePictureOnChange}
                            />

                            {state.supportRoles.length > 0 && <FormControl sx={{ m: 1 }}>
                                <InputLabel id="role">Role</InputLabel>
                                <Select
                                    disabled={true}
                                    labelId="role"
                                    id="role"
                                    value={state.role}
                                    defaultValue={state.role}
                                    onChange={handleSelect}
                                    input={<OutlinedInput label="Role" />}
                                    MenuProps={MenuProps}
                                >
                                    {state.supportRoles.map((object) => (
                                        <MenuItem
                                            key={object.role}
                                            value={object.role}>
                                            {object.role}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            }

                        </Stack>
                        <Actions>
                            <Button variant="contained" className='button' disabled={editable} onClick={() => { setEditable(true) }}>Edit profle</Button>
                            <Button variant="outlined" className='button' disabled={!editable} onClick={handleUpdate}>update profle</Button>
                        </Actions>
                    </Body>
                </>


            </Container>
        </>
    )
}

const Container = styled("div")`
    height: 100vh;
    width: 30vw;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    overflow: hidden;
    min-width:300px;
`;
const Header = styled("div")`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4{
        font-weight: 900;
        font-size: 120%;
    }
    padding-bottom: 0.7rem;
    border-bottom: 1px solid var(--card-border);
`;

const Body = styled("div")`
    margin-top: 1rem;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
`;
const Actions = styled("div")`
    margin-top: 1rem;
    display: grid;
    row-gap: 1rem;
`;

export default SubAdminProfile